import { ApiPathConfig } from '../types';
import { CreativeResponseDTO } from 'infrastructure/dtos/creative';
import { InstagramPostDTO } from 'infrastructure/dtos/instagramPost';
import { MediaUpdateDTO } from 'infrastructure/dtos/instagramPost';

export const InstagramPostsByUserId: ApiPathConfig<
  { userId: string },
  {
    posts: InstagramPostDTO[];
    user: CreativeResponseDTO;
  }
> = {
  method: 'GET',
  path: '/admin/instagram/posts/:userId',
  response: {
    posts: [] as InstagramPostDTO[],
    user: {} as CreativeResponseDTO,
  },
  body: {} as { userId: string },
  buildRoute: function (dto: { userId: string }): string {
    return this.path.replace(':userId', dto.userId);
  },
} as const;

export const InstagramPostAdminAction: ApiPathConfig<
  {
    posts: {
      id: string;
      action: 'publish' | 'reject';
      category_id: string;
      reason?: string;
    }[];
  },
  unknown
> = {
  method: 'POST',
  path: '/admin/instagram/posts/action',
  response: {} as unknown,
  body: {} as {
    posts: {
      id: string;
      action: 'publish' | 'reject';
      category_id: string;
      reason?: string;
    }[];
  },
} as const;

export const InstagramMediaUpdate: ApiPathConfig<MediaUpdateDTO, unknown> = {
  method: 'POST',
  path: '/admin/instagram/media/update',
  response: {} as unknown,
  body: {} as MediaUpdateDTO,
} as const;
